import React from 'react'

function ProviderTypeTab(): React.ReactElement {
  return <div>...</div>
}

export default ProviderTypeTab
